import { centralRegistryRepo } from "./centralRegistry.repo";
import {
  EvidencionaListaMaloprodajnihObjekataPayload,
  EvidencionaListaPosebanPostupakPayload,
  GetRegistryParams,
  MfListaObjekataPsPayload,
  RegistarMaloprodajnihCenaPayload,
  RegistarOMarkamaDuvanskihProizvodaPayload,
} from "./centralRegistry.types";

class CentralRegistryService {
  getRegistryData = (payload: GetRegistryParams) => {
    return centralRegistryRepo.getRegistryData(payload);
  };

  getRegistryConfig = () => {
    return centralRegistryRepo.getRegistryConfig();
  };

  getDetaljiObveznika = (id: number) => {
    return centralRegistryRepo.getDetaljiObveznika(id);
  };

  postRegistarOMarkamaDuvanskihProizvoda = (
    payload: RegistarOMarkamaDuvanskihProizvodaPayload
  ) => {
    return centralRegistryRepo.postRegistarOMarkamaDuvanskihProizvoda(payload);
  };

  postRegistarMaloprodajnihCena = (
    payload: RegistarMaloprodajnihCenaPayload
  ) => {
    return centralRegistryRepo.postRegistarMaloprodajnihCena(payload);
  };

  postEvidencionaListaPosebanPostupak = (
    payload: EvidencionaListaPosebanPostupakPayload
  ) => {
    return centralRegistryRepo.postEvidencionaListaPosebanPostupak(payload);
  };

  postEvidencionaListaMaloprodajnihObjekata = (
    payload: EvidencionaListaMaloprodajnihObjekataPayload
  ) => {
    return centralRegistryRepo.postEvidencionaListaMaloprodajnihObjekata(
      payload
    );
  };

  postPrivredniSubjektiPosebanPostupak = () => {
    return centralRegistryRepo.postPrivredniSubjektiPosebanPostupak();
  };

  postRegistarTrgovacaNaVeliko = () => {
    return centralRegistryRepo.postRegistarTrgovacaNaVeliko();
  };

  getMfTipoviObjekata = () => {
    return centralRegistryRepo.getMfTipoviObjekata();
  };

  postMfListaObjekataPs = (payload: MfListaObjekataPsPayload) => {
    return centralRegistryRepo.postMfListaObjekataPs(payload);
  };
}

export const centralRegistryService = new CentralRegistryService();
